<template>
  <div class="tutorial-bd bd" v-if="funcView.tms_product_list">
    <div class="tutorial-bd-content">
      <custom-tab v-model="activeTab" :list="langList" @change="getProductList()"></custom-tab>
      <div class="tab-content">
        <el-form :inline="true">
          <el-form-item style="margin: 0;">
            <el-button
              type="primary"
              icon="el-icon-plus"
              v-if="funcView.tms_product_add"
              @click="addTutorial()"
            >{{ funcView.tms_product_add }}</el-button>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right;margin: 0;">
            <el-input
              :placeholder="
              $t('training_tutorial.qsrcpxh')"
              v-model="formSearch.search"
              clearable
              @keyup.enter.native="getProductList()"
              style="width: 280px;"
            >
              <template slot="append">
                <div @click="getProductList()">
                  <i class="icon icon-search"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
          <!-- 型号 -->
          <div class="product-release-list" v-if="unPublished.length>0">
            <p class="titel">{{$t('training_tutorial.wei_fa_bu')}}</p>
            <ul>
              <li class="card-line" v-for="(item,index) in unPublished" :key="index">
                <!-- {{item.productId}} -->
                <div class="thumbnail" @click="funcView.tms_product_view && viewProduct(item)">
                  <!-- <i class="icon icon-ceshibaogao current"></i> -->
                  <!-- <div class="video" v-if="item.productVedio">
                    <video :src="item.productVedio">{{$t('com_your_browser_does_not_support_video_playback')}}</video>
                    <i class="icon icon-zanting"></i>
                  </div>
                  <img v-else :src="item.productAtlas" alt /> -->
                  <img :src="item.productAtlas" alt />
                </div>
                <div class="info">
                  <p>{{$t('training_tutorial.chan_pin_xing_hao')}}</p>
                  <span class="value">{{item.productCode}}</span>
                </div>
                <div class="inner">
                  <div class="param">
                    <div class="name">
                      <p>{{$t('training_tutorial.yu_zhong')}}</p>
                      <span class="value">{{language_type[item.langCode]}}</span>
                    </div>
                    <div class="name">
                      <p>{{$t('training_tutorial.pin_pai')}}</p>
                      <span class="value">{{iot_product_brand[item.productBrand]}}</span>
                    </div>
                    <div class="name">
                      <p>{{$t('training_tutorial.chuang_jian_ren')}}</p>
                      <span class="value">{{item.creator}}</span>
                    </div>
                    <div class="name">
                      <p>{{$t('training_tutorial.chuang_jian_shi_jian')}}</p>
                      <span class="value">{{momentAmPm($momentLocal(item.gmtCreate)) }}</span>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div
                    class="edit"
                    v-if="funcView.tms_product_edit_video"
                    @click="editTutorial(item, 2)"
                  >{{funcView.tms_product_edit_video}}</div>
                  <div
                    class="edit"
                    v-if="funcView.tms_product_edit"
                    @click="editTutorial(item)"
                  >{{funcView.tms_product_edit}}</div>
                  <div
                    class="delete"
                    v-if="funcView.tms_product_delete"
                    @click="deleteProduct(item)"
                  >{{funcView.tms_product_delete}}</div>
                  <div
                    class="details"
                    v-if="funcView.tms_product_publish"
                    @click="publishState(item)"
                  >
                    {{funcView.tms_product_publish}}
                    <!-- <i class="icon icon-you"></i> -->
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div class="product-releaseno-list" v-if="releaseList.length>0">
            <p class="titel">{{$t('training_tutorial.yi_fa_bu')}}</p>
            <ul>
              <li class="card-line" v-for="(item,index) in releaseList" :key="index">
                <div class="thumbnail" @click="funcView.tms_product_view && viewProduct(item)">
                  <!-- <i class="icon icon-ceshibaogao current"></i> -->
                  <!-- <div class="video" v-if="item.productVedio">
                    <video :src="item.productVedio">{{$t('com_your_browser_does_not_support_video_playback')}}</video>
                    <i class="icon icon-zanting"></i>
                  </div>
                  <img v-else :src="item.productAtlas" alt /> -->
                  <img :src="item.productAtlas" alt />
                </div>
                <div class="info">
                  <p>{{$t('training_tutorial.chan_pin_xing_hao')}}</p>
                  <span class="value">{{item.productCode}}</span>
                </div>
                <div class="inner">
                  <div class="param">
                    <div class="name">
                      <p>{{$t('training_tutorial.yu_zhong')}}</p>
                      <span class="value">{{language_type[item.langCode]}}</span>
                    </div>
                    <div class="name">
                      <p>{{$t('training_tutorial.pin_pai')}}</p>
                      <span class="value">{{iot_product_brand[item.productBrand]}}</span>
                    </div>
                    <div class="name">
                      <p>{{$t('training_tutorial.chuang_jian_ren')}}</p>
                      <span class="value">{{item.creator}}</span>
                    </div>
                    <div class="name">
                      <p>{{$t('training_tutorial.chuang_jian_shi_jian')}}</p>
                      <span class="value">{{momentAmPm($momentLocal(item.gmtCreate))}}</span>
                    </div>
                  </div>
                </div>
                <div class="more">
                  <div
                    class="edit"
                    v-if="funcView.tms_product_edit_video"
                    @click="editTutorial(item, 2)"
                  > {{funcView.tms_product_edit_video  }}</div>
                  <div
                    class="details"
                    v-if="funcView.tms_product_unPublish"
                    @click="publishStateNo(item)"
                  >
                    {{funcView.tms_product_unPublish}}
                    <!-- <i class="icon icon-you"></i> -->
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </el-form>
      </div>
    </div>
    <product-video-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
    ></product-video-dialog>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import productVideoDialog from './children/product_video_dialog.vue';

export default {
  name: 'tutorial',
  components: { productVideoDialog },
  data() {
    return {
      formSearch: {
        search: '',
        productState: '',
        langCode: ''
      },
      releaseList: [],
      unPublished: [],
      langList: [],
      language_type: {},
      iot_product_brand: {},
      activeTab: '',

      dialogVisible: false,
      dialogData: {},
      dialogModel: {}
    };
  },
  mounted() {
    this.getFuncView();

    this.getDictionary('language_type,iot_product_brand', (data) => {
      this.langList = data.language_type;
      this.language_type = this.$transformDicValue(data.language_type);
      this.iot_product_brand = this.$transformDicValue(data.iot_product_brand);
    });

    // 获取langCode
    this.activeTab = this.getJump('langCode') || Cookies.get('langCode') || 'CN';
    this.formSearch.langCode = this.langCode;
    this.getProductList();
  },
  methods: {
    addTutorial() {
      this.clearTagByKeep('tutorial_item');
      this.jump('/redirect/tutorial/add', { langCode: this.activeTab, parentPath: '/tutorial' });
    },
    editTutorial(item, step) {
      this.clearTagByKeep('tutorial_item');
      this.jump('/redirect/tutorial/edit', { langCode: item.langCode, productId: item.productId, step: step, parentPath: '/tutorial' });
    },
    getProductList: function () {
      this.formSearch.langCode = this.activeTab;
      this.$getJSON(apis.tmsProductList, this.formSearch).then((res) => {
        this.releaseList = res.data.filter(i => i.productState);
        this.unPublished = res.data.filter(i => !i.productState);
      });
    },
    viewProduct: function ({ productId, productName }) {
      this.dialogVisible = true;
      this.dialogData.productId = productId;
      this.dialogData.seeType = 'product';
      this.dialogModel.type = 'see';
      this.dialogModel.title = productName;
    },
    publishState: function ({ productId, productCode }) {
      const tips = this.$t('training_tutorial.qdyfbsxcpom', [productCode]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.tmsProductUpdateState, {
            productId,
            productState: 1
          }).then(() => {
            this.getProductList();
          });
        })
        .catch(() => {});
    },
    publishStateNo: function ({ productId, productCode }) {
      const tips = this.$t('training_tutorial.qdycxfbsxcpom', [productCode]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(apis.tmsProductUpdateState, {
            productId,
            productState: 0
          }).then(() => {
            this.getProductList();
          });
        })
        .catch(() => {});
    },
    // 删除产品
    deleteProduct: function ({ productId, productCode }) {
      const tips = this.$t('training_tutorial.qdyscsxcpom', [productCode]);
      this.$showConfirm(tips)
        .then(() => {
          this.$postJSON(`${apis.tmsProductDelete}/${productId}`).then(() => {
            this.getProductList();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.tutorial-bd {
  padding: 24px;
  background: #fff;
  height: auto !important;
  min-height: 100%;
  .tutorial-bd-content {
    background: #fff;
    // height: 100%;
    // overflow-y: auto;
    .tab-content {
      padding-top: 24px;
      .product-release-list,
      .product-releaseno-list {
        margin-top: 24px;
        padding: 25px 15px 16px 15px;
        border: 1px solid #e9ebec;
        position: relative;
        .titel {
          height: 17px;
          font-size: 12px;
          font-weight: bold;
          color: rgba(73, 80, 87, 1);
          line-height: 17px;
          padding: 0 14px;
          background-color: #fff;
          position: absolute;
          left: 24px;
          top: -8.5px;
        }
        ul {
          li {
            height: 70px;
            background: #ffffff;
            padding: 13px 17px 13px 16px;
            display: flex;
            align-items: center;
            // justify-content: space-between;
            .thumbnail {
              width: 70px;
              height: 44px;
              // margin-right: 24px;
              cursor: pointer;
              // overflow: hidden;
              // .icon{
              //   font-size: 44px;
              //   color:#D1D5D9;
              // }
              // .current{
              //   color: #0D9AE0;
              // }
              .video {
                display: block;
                width: 70px;
                height: 44px;
                position: relative;
                .icon {
                  text-align: center;
                  font-size: 16px;
                  position: absolute;
                  color: #eeeeeb;
                  position: absolute;
                  // top: 50%;
                  // left: 50%;
                  // transform: translate(-50%,-50%);
                  top: 0;
                  width: 70px;
                  height: 44px;
                  opacity: 0.3;
                  background: #000;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
              }
              video,
              img {
                display: block;
                // height: 100%;
                width: 70px;
                height: 44px;
              }
            }
            .info {
              padding: 0 16px;
              flex-shrink: 0;
              width: 250px;
              height: 40px;
              overflow: hidden;
              align-self: center;
              p {
                height: 17px;
                font-size: 12px;
                color: rgba(152, 166, 173, 1);
                line-height: 17px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              span {
                height: 25px;
                font-size: 12px;
                font-weight: bold;
                color: rgba(73, 80, 87, 1);
                line-height: 25px;
                display: inline-block;
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
            .inner {
              flex: 1;
              overflow-x: auto;
              .param {
                display: flex;
                overflow-x: auto;
                .name {
                  padding: 0 16px;
                  border-right: 1px solid #e9ebec;
                  flex-shrink: 0;
                  width: 92px;
                  height: 40px;
                  overflow: hidden;
                  align-self: center;
                  p {
                    height: 17px;
                    font-size: 12px;
                    color: rgba(152, 166, 173, 1);
                    line-height: 17px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  span {
                    height: 25px;
                    font-size: 12px;

                    // font-weight: bold;
                    color: rgba(73, 80, 87, 1);
                    line-height: 25px;
                    display: inline-block;
                    width: 60px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  }
                  &:nth-last-child(2){
                     width: 120px;
                  }
                  &:last-of-type {
                    width: 163px;
                    border: none !important;
                    span {
                      height: 25px;
                      font-size: 12px;
                      // font-weight: bold;
                      color: rgba(73, 80, 87, 1);
                      line-height: 25px;
                      display: inline-block;
                      width: 170px;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    }
                  }
                }
              }
            }
            .card-title {
              height: 21px;
              font-size: 12px;

              font-weight: bold;
              color: rgba(73, 80, 87, 1);
              line-height: 21px;
              .user {
                height: 21px;
                font-size: 12px;
                color: rgba(57, 70, 104, 1);
                line-height: 21px;
              }
              .right {
                float: right;
                height: 17px;
                font-size: 12px;
                color: rgba(13, 154, 224, 1);
                line-height: 17px;
              }
            }
            .card-tips {
              height: 17px;
              font-size: 12px;
              color: rgba(108, 117, 125, 1);
              line-height: 17px;
              .right {
                float: right;
                height: 17px;
                font-size: 12px;
                color: rgba(108, 117, 125, 1);
                line-height: 17px;
              }
            }
            &:hover {
              background: #f9f9fd;
            }
            .more {
              margin-left: auto;
              display: flex;

              .edit,
              .delete,
              .details {
                flex-shrink: 0;
                color: #0d9ae0;
                font-size: 12px;
                color: rgba(13, 154, 224, 1);
                line-height: 22px;
                cursor: pointer;
                padding: 0 20px;
                border-right: 1px solid #e9ebec;
                i {
                  color: #0d9ae0;
                  font-size: 12px;
                  margin: 0;
                }
              }
              .details {
                padding-right: 0;
                border: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
